<template>
    <transition name="modal">
        <div class="modal-mask modal-mask-for-log">
            <div class="modal-wrapper">
                <div class="modal-container-log">
                    <div class="modal-header">
                        <h5 class="modal-title">{{dataToPassToModal.command}}
                            <small>{{dataToPassToModal.deviceIp}}</small>
                        </h5>
                        <button type="button" class="close" @click="$emit('close')" data-dismiss="modal"
                                aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="dataToPassToModal.command.endsWith('splunk')">
                            <small>
                                Showing a maximum of {{maxSplunkResults}} results in the past {{maxSplunkTimeframeDays}} days.
                                <a
                                    v-if="splunkSearchResultsFullLink !== ''"
                                    v-bind:href="splunkSearchResultsFullLink"
                                    target="_blank"
                                    style="text-decoration: underline; color: blue;"
                                >View in Splunk</a>
                            </small>
                            <br>
                            <small>
                                Progress: {{ (splunkSearchResultsProgress * 100).toFixed(2) }}% | {{splunkSearchResultsInfo}}
                            </small>
                        </div>
                        <div class="table-responsive modal-body-table-responsive">
                            <table class="table table-striped table-hover logs-table">
                                <thead v-if="dataToPassToModal.command === 'event-logs' || dataToPassToModal.command === 'event-logs-splunk'" class="thead-dark">
                                <th>Server</th>
                                <th>Device</th>
                                <th>Message</th>
                                <th>Event</th>
                                <th>event_time</th>
                                <th>msg_seq_num</th>
                                <th>SN</th>
                                <th>gw_ip_addr</th>
                                <th>event_number</th>
                                <th>event_flags</th>
                                </thead>
                                <tbody v-if="dataToPassToModal.command
                                 === 'event-logs'">
                                <tr v-for="data in modalData">
                                    <td>{{data.key[0]}}</td>
                                    <td>{{data.key[1]}}</td>
                                    <td>{{event_mapping[data.data.event_id]}}</td>
                                    <td>{{data.data.event_id}}</td>
                                    <td>{{data.data.event_time}}</td>
                                    <td>{{data.data.msg_seq_num}}</td>
                                    <td>{{data.data.sn}}</td>
                                    <td>{{data.data.gw_ip_addr}}</td>
                                    <td>{{data.data.event_number}}</td>
                                    <td>{{data.data.event_flags}}</td>
                                </tr>
                                </tbody>
                                <tbody v-if="dataToPassToModal.command === 'event-logs-splunk'">
                                <tr v-for="data in modalData">
                                  <td>{{data.serverTime}}</td>
                                  <td>{{data.deviceTime}}</td>
                                  <td>{{event_mapping[data.eventId]}}</td>
                                  <td>{{data.eventId}}</td>
                                  <td>{{data.eventTime}}</td>
                                  <td>{{data.msgSeqNum}}</td>
                                  <td>{{data.sn}}</td>
                                  <td>{{data.gwIpAddress}}</td>
                                  <td>{{data.eventNumber}}</td>
                                  <td>{{data.eventFlags}}</td>
                                </tr>
                                </tbody>
                                <thead v-if="dataToPassToModal.command === 'logs' || dataToPassToModal.command === 'full-logs-splunk'" class="thead-dark">
                                <th>Server Time</th>
                                <th>msg_id</th>
                                <th>msg_seq_num</th>
                                <th>gw_ip_addr</th>
                                <th>device_firmware</th>
                                <th>ble_version</th>
                                <th>ble_softwareID</th>
                                <th>freq</th>
                                <th>device_cat</th>
                                </thead>
                                <tbody v-if="dataToPassToModal.command === 'logs'">
                                <tr v-for="data in modalData">
                                    <td>{{data.key[0]}}</td>
                                    <td>{{data.data.msg_id}}</td>
                                    <td>{{data.data.msg_seq_num}}</td>
                                    <td>{{data.data.gw_ip_addr}}</td>
                                    <td>{{data.data.device_firmware}}</td>
                                    <td>{{data.data.ble_version}}</td>
                                    <td>{{data.data.ble_softwareID}}</td>
                                    <td>{{data.data.freq}}</td>
                                    <td>{{data.data.device_cat}}</td>
                                </tr>
                                </tbody>
                                <tbody v-if="dataToPassToModal.command === 'full-logs-splunk'">
                                <tr v-for="data in modalData">
                                    <td>{{data.serverTime}}</td>
                                    <td>{{data.msgId}}</td>
                                    <td>{{data.msgSeqNum}}</td>
                                    <td>{{data.networkId}}</td>
                                    <td>{{data.deviceFirmware}}</td>
                                    <td>{{data.bleVersion}}</td>
                                    <td>{{data.bleSoftwareID}}</td>
                                    <td>{{data.freq}}</td>
                                    <td>{{data.deviceCat}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                      <hr/>
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <button type="button" class="btn btn-info" @click="loadLog(prev.api.timestamp)"
                                    :disabled="prev.api.disabled">{{prev.api.text}}</button>
                            <button type="button" class="btn btn-secondary" @click="loadLogData(dataToPassToModal.command, next.payload, true)"
                                    :disabled="next.disabled">Earlier
                            </button>
                            <span class="btn btn-light disabled">{{currentTitle}}</span>
                            <button type="button" class="btn btn-secondary" @click="loadLogData(dataToPassToModal.command, prev.payload, false)"
                                    :disabled="prev.disabled">Later
                            </button>
                            <button type="button" class="btn btn-info" @click="loadLog(next.api.timestamp)"
                                    :disabled="next.api.disabled">{{next.api.text}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
  "use strict";
  import axios from 'axios'

  const SPLUNK_POLL_INTERVAL_MS = 400;
  const SPLUNK_POLL_MAX_ATTEMPTS = 20;
  const SPLUNK_MAX_RESULTS = 1000;
  const SPLUNK_MAX_TIMEFRAME_DAYS = 90; // Last 90 days
  function splunkSearch(command, ipAddress) {
    if (command === 'event-logs-splunk') {
      return `search \`device-to-cloud\` packet.ipAddress="${ipAddress}" packet.msgId=6\n` +
          `| head ${SPLUNK_MAX_RESULTS}\n` +
          '| rename _time as serverTime\n' +
          '| rename packet.v1.event_id as eventId\n' +
          '| rename packet.v1.event_time as eventTime\n' +
          '| rename packet.v1.msg_seq_num as msgSeqNum\n' +
          '| rename packet.v1.sn as sn\n' +
          '| rename packet.v1.gw_ip_addr as gwIpAddress\n' +
          '| rename packet.v1.event_number as eventNumber\n' +
          '| rename packet.v1.event_flags as eventFlags\n' +
          '| table serverTime, deviceTime, eventId, eventTime, msgSeqNum, sn, gwIpAddress, eventNumber, eventFlags\n' +
          '| sort -serverTime';
    } else if (command === 'full-logs-splunk') {
      return `search \`device-to-cloud\` packet.ipAddress="${ipAddress}"\n` +
          `| head ${SPLUNK_MAX_RESULTS}\n` +
          '| rename _time as serverTime\n' +
          '| rename packet.msgId as msgId\n' +
          '| rename packet.msgSeqNum as msgSeqNum\n' +
          '| rename packet.networkId as networkId\n' +
          '| rename packet.v1.device_firmware as deviceFirmware\n' +
          '| rename packet.v1.ble_version as bleVersion\n' +
          '| rename packet.v1.ble_softwareID as bleSoftwareID\n' +
          '| rename packet.v1.freq as freq\n' +
          '| rename packet.v1.device_cat as deviceCat\n' +
          '| table serverTime, msgId, msgSeqNum, networkId, deviceFirmware, bleVersion, bleSoftwareID, freq, deviceCat\n' +
          '| sort -serverTime';
    } else {
      console.error(`Unknown command ${command} in splunkSearch`);
    }
  }

  export default {
    props: {
      dataToPassToModal: Object,
    },
    data () {
      return {
        modalData: [],
        splunkSearchResultsProgress: 0,
        splunkSearchResultsInfo: '',
        splunkSearchResultsFullLink: '',
        event_mapping: [],
        host: '',
        prev: {
          title: '',
          payload: {
            service: '',
            token: null
          },
          disabled: false,
          api: {
            timestamp: Math.round(Date.now()/1000),
            text: '',
            disabled: false
          },
        },
        next: {
          title: '',
          payload: {
            service: '',
            token: null
          },
          disabled: false,
          api: {
            timestamp: Math.round(Date.now()/1000),
            text: '',
            disabled: false
          },
        },
        currentTitle: '',
        current: 0,
        total: 0,
        prev_page_size: 0
      };
    },
    mounted () {
      this.loadLog(Math.round(Date.now()/1000));
    },
    methods: {
      formatBytes: function (a,b){
        if(0==a)return"0 Bytes";var c=1024,d=b||2,e=["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"],f=Math.floor(Math.log(a)/Math.log(c));return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f]
      },
      getY: function (timestamp) {
        let date = new Date(parseInt(timestamp) * 1000);

        return `${date.getFullYear()}`;
      },
      getYM: function (timestamp) {
        let date = new Date(parseInt(timestamp) * 1000);

        return date.toLocaleString('en-AU', {year: 'numeric', month: 'short'});
      },
      processLogResult: function (command, data) {
        if(command === 'logs') {
          let { hits = [] } = data.data?.hits;
          for (let i = 0; i < hits.length; i++) {
            let serverDate = new Date(hits[i].sort[0]);
            let title = [
              `${serverDate.toLocaleString('en-GB')}`,
              `Message: ${hits[i]._source.package.ip_addr}`
            ];

            this.modalData.push({
              'key': title,
              'data': hits[i]._source.package,
            });
          }
        }
        return this;
      },
      processEventLogResult: function (command, data) {
        if (command === 'event-logs') {
          let { hits = [] } = data.data?.hits;
          for (let i = 0; i < hits.length; i++) {
            let serverDate = new Date(hits[i].sort[0]),
              deviceDate = new Date(hits[i]._source.package.event_time),
              title = [
                `${serverDate.toLocaleString('en-GB')}`,
                `${deviceDate.toLocaleString('en-GB')}`,
                `${hits[i]._source.package.ip_addr}`
              ];

            this.modalData.push({
              'key': title,
              'data': hits[i]._source.package,
            });
          }
        }
        return this;
      },
      loadLog: function (timestamp) {
        let query = '';
        if(timestamp !== undefined) {
          query = `?timestamp=${parseInt(timestamp)}`;
        }
        let command = this.dataToPassToModal.command;

        // Reset modal controls and data
        this.modalData = [];
        this.splunkSearchResultsProgress = 0;
        this.splunkSearchResultsInfo = '';
        this.splunkSearchResultsFullLink = '';
        this.prev.disabled = true;
        this.next.disabled = true;
        this.prev.api.disabled = true;
        this.next.api.disabled = true;

        this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/devices-commands/${this.dataToPassToModal.deviceId}/${command}${query}`,
          path_template: '/api/devices-commands/{device_id}/' + command
        }).then(response => {
          if(response.data.meta.event_mapping && !this.event_mapping.length) {
            this.event_mapping = response.data.meta.event_mapping;
          }
          // Legacy variants
          if (command === 'event-logs' || command === 'logs') {
            this.host = response.data.meta.host;
            this.current = 0;
            this.prev.api.timestamp = response.data.meta.prev;
            this.prev.api.text = command === 'event-logs' ? this.getY(this.prev.api.timestamp) : this.getYM(this.prev.api.timestamp);
            this.prev.api.disabled = this.prev.api.timestamp < 1420070400;
            this.next.api.timestamp = response.data.meta.next;
            this.next.api.text = command === 'event-logs' ? this.getY(this.next.api.timestamp) : this.getYM(this.next.api.timestamp);
            this.next.api.disabled = (this.next.api.timestamp - (Date.now() / 1000 + (60 * 60 * 24))) > 0;
            this.currentTitle = command === 'event-logs' ? this.getY(timestamp) : this.getYM(timestamp);
            return this.loadLogData(command, response.data.data, true);
          } else {
            // Splunk variants - the response contains the session id used for authentication
            return this.loadLogData(command, response.data.data, true);
          }
        })
      },
      loadLogData: async function (command, payload, next = true) {
        if (command.endsWith('splunk')) {
          // payload looks like {"session_key": "..."}

          // Limit Splunk search time range so that it doesn't take forever
          const earliest = new Date();
          earliest.setDate(earliest.getDate() - SPLUNK_MAX_TIMEFRAME_DAYS);
          const latest = new Date();

          // Initiate the job with the relevant parameters
          const createSearchJobRequest = new URLSearchParams();
          createSearchJobRequest.append('output_mode', 'json');
          createSearchJobRequest.append('search', splunkSearch(command, this.dataToPassToModal.deviceIp));
          createSearchJobRequest.append('earliest_time', earliest.toISOString());
          createSearchJobRequest.append('latest_time', latest.toISOString());
          // eg, {"sid": "1638511898.199"}
          const jobResponse = await axios.post(
              'https://splunk.wbstech.com.au:8089/services/search/jobs',
              createSearchJobRequest,
              {
                headers: {
                  'Content-type': 'application/x-www-form-urlencoded',
                  'Authorization': `Splunk ${payload['session_key']}`,
                },
              }
          );

          // Update info in modal
          this.splunkSearchResultsProgress = 0;
          this.splunkSearchResultsFullLink = `https://splunk.wbstech.com.au/en-US/app/search/search?sid=${jobResponse.data.sid}`;

          // Wait until search is done, up to a maximum of 200ms * 20 = 4 seconds
          let isDone = false;
          let resultCount = 0;
          let attempts = 0;
          while (!isDone && attempts < SPLUNK_POLL_MAX_ATTEMPTS) {
            this.splunkSearchResultsProgress = attempts / SPLUNK_POLL_MAX_ATTEMPTS;
            const statusResponse = await axios.get(
                `https://splunk.wbstech.com.au:8089/services/search/jobs/${jobResponse.data.sid}`,
                {
                  headers: {
                    'Content-type': 'application/x-www-form-urlencoded',
                    'Authorization': `Splunk ${payload['session_key']}`,
                  },
                  params: {
                    output_mode: 'json',
                  },
                },
            );

            // We use the isDone flag to decide when to stop. But the actual results fetching is done constantly
            // and incrementally, as soon as we see that new results are available.
            isDone = statusResponse.data.entry[0].content.isDone;
            const newResultCount = statusResponse.data.entry[0].content.resultCount;
            if (newResultCount > resultCount) {
              // Incrementally display search results
              this.modalData = await this.fetchSplunkResults(command, payload['session_key'], jobResponse.data.sid);
              resultCount = newResultCount;
            }

            // Sleep
            await new Promise(resolve => setTimeout(resolve, SPLUNK_POLL_INTERVAL_MS));
            attempts++;
          }

          // Show final message
          if (isDone) {
            this.splunkSearchResultsProgress = 1; // Show as complete
            this.splunkSearchResultsInfo = `Fetched ${this.modalData.length} results in ${(attempts * SPLUNK_POLL_INTERVAL_MS / 1000).toFixed(2)} seconds`;
          } else {
            this.splunkSearchResultsInfo = `Timed out. Fetched ${this.modalData.length} results in ${(attempts * SPLUNK_POLL_INTERVAL_MS / 1000).toFixed(2)} seconds`;
          }
        } else {
          return axios({
            headers: {
              'Content-Type': 'application/json',
            },
            validateStatus: function (status) {
              return [200, 201, 204, 400, 401, 409, 410, 422].indexOf(status) > -1
            },
            method: 'POST',
            url: this.host,
            data: payload
          }).then(response => {
            this.modalData = [];
            let {hits = [], total: {value: totalValue, relation: totalRelation}} = response.data.data?.hits;
            this.total = totalRelation === 'eq' ? totalValue : `greater than ${totalValue}`;
            this.current += next ? hits.length : -1 * this.prev_page_size;

            this.processLogResult(command, response.data)
                .processEventLogResult(command, response.data);

            this.prev_page_size = hits.length;
            this.prev.payload.service = response.data?.meta?.prev?.service;
            this.prev.payload.token = response.data?.meta?.prev?.token;
            this.prev.disabled = !this.prev.payload.token;
            this.next.payload.service = response.data?.meta?.next?.service;
            this.next.payload.token = response.data?.meta?.next?.token;
            this.next.disabled = !this.next.payload.token;
          });
        }
      },
      fetchSplunkResults: async function(command, sessionKey, sid) {
        // Get results from the search now that it's done
        const resultsResponse = await axios.get(
            `https://splunk.wbstech.com.au:8089/services/search/jobs/${sid}/results`,
            {
              headers: {
                'Content-type': 'application/x-www-form-urlencoded',
                'Authorization': `Splunk ${sessionKey}`,
              },
              params: {
                output_mode: 'json',
              },
            }
        );

        // Post-process the results to match original format
        if (command === 'event-logs-splunk') {
          return resultsResponse.data.results.map((result) => {
            result.serverTime = new Date(result.serverTime * 1000).toLocaleString('en-GB');
            result.deviceTime = new Date(result.eventTime * 1000).toLocaleString('en-GB');
            return result;
          });
        } else if (command === 'full-logs-splunk') {
          return resultsResponse.data.results.map((result) => {
            result.serverTime = new Date(result.serverTime * 1000).toLocaleString('en-GB');
            return result;
          });
        } else {
          console.error(`Unknown command ${command} in fetchSplunkResults`);
        }
      }
    },
    computed: {
      maxSplunkResults: () => SPLUNK_MAX_RESULTS,
      maxSplunkTimeframeDays: () => SPLUNK_MAX_TIMEFRAME_DAYS,
    }
  }
</script>
<style scoped>
.logs-table thead th {
        position: sticky;
        position: -webkit-sticky;
        top: -1px;
        z-index: 10;
    }
    .logs-table td {
        white-space: nowrap;
    }
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
    .modal-mask-for-log .modal-container {
        height: 100vh;
        overflow: scroll;
    }

    .modal-mask-for-log .list-group + .list-group {
        margin-top: 20px;
    }
    .modal-mask-for-log .btn-group {
        width: 100%;
    }
    .modal-mask-for-log .btn-group .btn {width:33.33%;}

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container-log{
        width: 1400px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 0;
        overflow: hidden;
    }

    .modal-body-table-responsive {
        max-height: calc(100vh - 297px);
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>